"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.embroideryEffect = embroideryEffect;
var _createCanvas = require("../Utils/createCanvas");
var _imagePreloader = require("../Utils/imagePreloader");
var _createCache = require("../Utils/createCache");
var _embroidery_screen = _interopRequireDefault(require("./resources/embroidery_screen.jpg"));
var _embroidery_multiply = _interopRequireDefault(require("./resources/embroidery_multiply.jpg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var imagePreloader = (0, _imagePreloader.createImagePreloader)([_embroidery_screen["default"], _embroidery_multiply["default"]]);
var SVG_DATA_URL_HDR = "data:image/svg+xml;base64,";
var getScaleValues = function getScaleValues(node) {
  var transform = node.getAttribute("transform") || "";
  var matches = transform.match(/scale\(([^)]+)\)/);
  if (matches) {
    var _matches$1$split$map = matches[1].split(",").map(window.parseFloat),
      _matches$1$split$map2 = _slicedToArray(_matches$1$split$map, 2),
      x = _matches$1$split$map2[0],
      y = _matches$1$split$map2[1];
    return [x, y || x];
  }
  return [1, 1];
};
var getRotateValue = function getRotateValue(node) {
  var transform = node.getAttribute("transform") || "";
  var matches = transform.match(/rotate\(([^)]+)\)/);
  if (matches) {
    return window.parseFloat(matches[1]);
  }
  return 0;
};
var getSizeValues = function getSizeValues(svgNode) {
  return [parseFloat(svgNode.getAttribute("width")) || 0, parseFloat(svgNode.getAttribute("height")) || 0];
};
var findOutermostNode = function findOutermostNode(node, container) {
  return node.parentNode ? node.parentNode === container ? node : findOutermostNode(node.parentNode, container) : node;
};
var svgToImg = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(svgElement) {
    var svgImg;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return new Promise(function (resolve, reject) {
            var img = document.createElement("img");
            img.onload = function () {
              return resolve(img);
            };
            img.onerror = reject;
            var xml = _typeof(svgElement) === "object" ? new XMLSerializer().serializeToString(svgElement) : svgElement;
            var svg64 = btoa(xml);
            img.src = "data:image/svg+xml;base64," + svg64;
          });
        case 2:
          svgImg = _context.sent;
          _context.next = 5;
          return new Promise(function (resolve) {
            setTimeout(function () {
              // some browsers may have issues with applying effects on images with svg source
              // therefore it has to be converted to a canvas before
              // it also has to be performed in a new event to make sure the image content is available
              var _createWorkingCanvas = (0, _createCanvas.createWorkingCanvas)(svgImg, true),
                _createWorkingCanvas2 = _slicedToArray(_createWorkingCanvas, 1),
                svgCanvas = _createWorkingCanvas2[0];
              resolve(svgCanvas);
            });
          });
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function svgToImg(_x) {
    return _ref.apply(this, arguments);
  };
}();
var applyOnEmbeddedSvg = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(imageNode, imageCanvas, ctx, rootSvgElement) {
    var outermostGroup, _getScaleValues, _getScaleValues2, rootScaleX, rootScaleY, _getScaleValues3, _getScaleValues4, imgScaleX, imgScaleY, _getSizeValues, _getSizeValues2, rootWidth, canvasWidth, svgToCanvasRatio, scaleX, scaleY, size, _createWorkingCanvas3, _createWorkingCanvas4, tmpCanvas, tmpCtx, svgAsString, svgDoc, svgElement, x, y, angle;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          outermostGroup = findOutermostNode(imageNode, rootSvgElement);
          _getScaleValues = getScaleValues(outermostGroup), _getScaleValues2 = _slicedToArray(_getScaleValues, 2), rootScaleX = _getScaleValues2[0], rootScaleY = _getScaleValues2[1];
          _getScaleValues3 = getScaleValues(imageNode), _getScaleValues4 = _slicedToArray(_getScaleValues3, 2), imgScaleX = _getScaleValues4[0], imgScaleY = _getScaleValues4[1];
          _getSizeValues = getSizeValues(rootSvgElement), _getSizeValues2 = _slicedToArray(_getSizeValues, 1), rootWidth = _getSizeValues2[0];
          canvasWidth = imageCanvas.width;
          svgToCanvasRatio = canvasWidth / rootWidth;
          scaleX = imgScaleX * rootScaleX * svgToCanvasRatio;
          scaleY = imgScaleY * rootScaleY * svgToCanvasRatio;
          size = {
            width: parseFloat(imageNode.getAttribute("width")) * scaleX,
            height: parseFloat(imageNode.getAttribute("height")) * scaleY
          };
          _createWorkingCanvas3 = (0, _createCanvas.createWorkingCanvas)(size), _createWorkingCanvas4 = _slicedToArray(_createWorkingCanvas3, 2), tmpCanvas = _createWorkingCanvas4[0], tmpCtx = _createWorkingCanvas4[1];
          _context2.prev = 10;
          svgAsString = window.atob(getImageSrc(imageNode).substring(SVG_DATA_URL_HDR.length));
          svgDoc = new DOMParser().parseFromString(svgAsString, "image/svg+xml");
          svgElement = svgDoc.getElementsByTagName("svg")[0];
          _context2.next = 16;
          return Promise.all(Array.from(svgElement.childNodes).map(applyOnChildNode(tmpCanvas, tmpCtx, svgElement)));
        case 16:
          ctx.save();

          // apply element transformations
          x = parseFloat(imageNode.getAttribute("x"));
          y = parseFloat(imageNode.getAttribute("y"));
          angle = getRotateValue(imageNode) / 180 * Math.PI;
          ctx.rotate(angle);
          ctx.translate(x * scaleX, y * scaleY);
          ctx.drawImage(tmpCanvas, 0, 0);
          ctx.restore();
          _context2.next = 29;
          break;
        case 26:
          _context2.prev = 26;
          _context2.t0 = _context2["catch"](10);
          // eslint-disable-next-line no-console
          console.error("Error during embedded svg image processing!", _context2.t0);
        case 29:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[10, 26]]);
  }));
  return function applyOnEmbeddedSvg(_x2, _x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var getImageSrc = function getImageSrc(imageNode) {
  return imageNode.getAttribute("href") || imageNode.getAttribute("xlink:href");
};
var applyOnChildNode = function applyOnChildNode(imageCanvas, ctx, svgElement) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(node) {
      var partialSvg, img, rotation, _createWorkingCanvas5, _createWorkingCanvas6, multiplyPatternCanvas, multiplyPatternContext, patternSize, _createWorkingCanvas7, _createWorkingCanvas8, screenPatternCanvas, screenPatternContext, _createWorkingCanvas9, _createWorkingCanvas10, ocvs, octx;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(node.nodeType === 3 /** ignore text nodes **/ || node.getAttribute("visibility") === "hidden")) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            if (!(node.tagName === "image")) {
              _context3.next = 7;
              break;
            }
            if (!getImageSrc(node).startsWith(SVG_DATA_URL_HDR)) {
              _context3.next = 7;
              break;
            }
            _context3.next = 6;
            return applyOnEmbeddedSvg(node, imageCanvas, ctx, svgElement);
          case 6:
            return _context3.abrupt("return");
          case 7:
            partialSvg = createSvgChunk(imageCanvas, svgElement, node);
            if (partialSvg) {
              _context3.next = 10;
              break;
            }
            return _context3.abrupt("return");
          case 10:
            _context3.next = 12;
            return svgToImg(partialSvg);
          case 12:
            img = _context3.sent;
            rotation = Math.random() * Math.PI;
            _createWorkingCanvas5 = (0, _createCanvas.createWorkingCanvas)(imageCanvas), _createWorkingCanvas6 = _slicedToArray(_createWorkingCanvas5, 2), multiplyPatternCanvas = _createWorkingCanvas6[0], multiplyPatternContext = _createWorkingCanvas6[1];
            multiplyPatternContext.fillStyle = ctx.createPattern(imagePreloader.get(_embroidery_multiply["default"]), "repeat");
            patternSize = Math.max(img.width, img.height) * 4;
            multiplyPatternContext.rotate(rotation);
            multiplyPatternContext.fillRect(-patternSize / 2, -patternSize / 2, patternSize, patternSize);
            _createWorkingCanvas7 = (0, _createCanvas.createWorkingCanvas)(imageCanvas), _createWorkingCanvas8 = _slicedToArray(_createWorkingCanvas7, 2), screenPatternCanvas = _createWorkingCanvas8[0], screenPatternContext = _createWorkingCanvas8[1];
            screenPatternContext.fillStyle = ctx.createPattern(imagePreloader.get(_embroidery_screen["default"]), "repeat");
            screenPatternContext.rotate(rotation);
            screenPatternContext.fillRect(-patternSize / 2, -patternSize / 2, patternSize, patternSize);
            _createWorkingCanvas9 = (0, _createCanvas.createWorkingCanvas)(imageCanvas), _createWorkingCanvas10 = _slicedToArray(_createWorkingCanvas9, 2), ocvs = _createWorkingCanvas10[0], octx = _createWorkingCanvas10[1]; // Add multiply Effect
            octx.globalCompositeOperation = "destination-atop";
            octx.drawImage(multiplyPatternCanvas, 0, 0);
            octx.drawImage(img, 0, 0);
            ctx.globalCompositeOperation = "screen";
            ctx.drawImage(ocvs, 0, 0);

            // Add Screen Effect
            octx.globalCompositeOperation = "destination-atop";
            octx.drawImage(screenPatternCanvas, 0, 0);
            octx.drawImage(img, 0, 0);
            ctx.globalCompositeOperation = "multiply";
            ctx.drawImage(ocvs, 0, 0);

            // Draw SVG again behind
            ctx.globalCompositeOperation = "multiply";
            ctx.drawImage(img, 0, 0);
          case 36:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var createSvgChunk = function createSvgChunk(imageCanvas, svgRoot, endNode) {
  var styleTags = ["style", "defs"];
  if (endNode.nodeType === Node.TEXT_NODE || styleTags.indexOf(endNode.tagName) !== -1) {
    return false;
  }
  var chunk = svgRoot.cloneNode();
  for (var _i = 0, _styleTags = styleTags; _i < _styleTags.length; _i++) {
    var tagName = _styleTags[_i];
    var elements = _toConsumableArray(svgRoot.getElementsByTagName(tagName));
    var _iterator = _createForOfIteratorHelper(elements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        chunk.appendChild(element.cloneNode(true));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  chunk.appendChild(cloneWithParent(endNode, svgRoot));
  var width = imageCanvas.width,
    height = imageCanvas.height;
  chunk.setAttribute("width", width);
  chunk.setAttribute("height", height);
  return chunk;
};
var setSvgSize = function setSvgSize(svgElement, _ref4) {
  var width = _ref4.width,
    height = _ref4.height;
  var scale = svgElement.getAttribute("width") / width;
  svgElement.setAttribute("width", width);
  svgElement.setAttribute("height", height);
  if (svgElement.hasAttribute("viewBox")) {
    var _svgElement$getAttrib = svgElement.getAttribute("viewBox").split(/[\s,]/),
      _svgElement$getAttrib2 = _slicedToArray(_svgElement$getAttrib, 2),
      x = _svgElement$getAttrib2[0],
      y = _svgElement$getAttrib2[1];
    svgElement.setAttribute("viewBox", [x, y, width, height].join(" "));
  }
  updateViewGroupScale(svgElement, scale);
  return scale;
};
var updateViewGroupScale = function updateViewGroupScale(svgElement, ratio) {
  var viewGroup = svgElement.getElementById("viewGroup");
  if (viewGroup) {
    var _getScaleValues5 = getScaleValues(viewGroup),
      _getScaleValues6 = _slicedToArray(_getScaleValues5, 2),
      sx = _getScaleValues6[0],
      sy = _getScaleValues6[1];
    viewGroup.setAttribute("transform", "scale(".concat(sx / ratio, ",").concat(sy / ratio, ")"));
  }
};
var cloneWithParent = function cloneWithParent(node, outermostParent) {
  var n = node;
  var clone = n.cloneNode(true); // the end node should be copied deeply
  while (n.parentNode && n.parentNode !== outermostParent) {
    var child = clone;
    n = n.parentNode;
    clone = n.cloneNode();
    clone.appendChild(child);
  }
  return clone;
};
var traverseDOM = function traverseDOM(node, cb) {
  cb(node);
  var childNodes = node.childNodes;
  var length = childNodes.length;
  if (length > 0) {
    for (var i = 0; i < length; i++) {
      traverseDOM(childNodes[i], cb);
    }
  }
};
var collectEndNodes = function collectEndNodes(node) {
  var nodes = [];
  traverseDOM(node, function (node) {
    if (node.tagName === "path" || node.tagName === "image") {
      nodes.push(node);
    }
  });
  return nodes;
};
var getEffectKey = function getEffectKey(svgAsString, srcCanvas) {
  var width = srcCanvas.width,
    height = srcCanvas.height;
  return [svgAsString, width, height].join("-");
};
var createEffectImg = function () {
  var cache = (0, _createCache.createCache)(10);
  return /*#__PURE__*/function () {
    var _createEffectImg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(svgAsString, srcCanvas) {
      var key, cachedResult, svgDoc, svgElement, _getSizeValues3, _getSizeValues4, cWidth, cHeight, aspectRatio, width, height, _createWorkingCanvas11, _createWorkingCanvas12, imageCanvas, ctx, designerLayer, childNodes, image, _getScaleValues7, _getScaleValues8, sx, sy, resultImgPromise;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            key = getEffectKey(svgAsString, srcCanvas);
            _context4.next = 3;
            return cache.get(key);
          case 3:
            cachedResult = _context4.sent;
            if (!cachedResult) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return", cachedResult);
          case 6:
            svgDoc = new DOMParser().parseFromString(svgAsString, "image/svg+xml");
            svgElement = svgDoc.getElementsByTagName("svg")[0];
            _getSizeValues3 = getSizeValues(svgElement), _getSizeValues4 = _slicedToArray(_getSizeValues3, 2), cWidth = _getSizeValues4[0], cHeight = _getSizeValues4[1];
            aspectRatio = cWidth / cHeight;
            width = srcCanvas.width;
            height = Math.round(width / aspectRatio);
            setSvgSize(svgElement, {
              width: width,
              height: height
            });
            _createWorkingCanvas11 = (0, _createCanvas.createWorkingCanvas)({
              width: width,
              height: height
            }), _createWorkingCanvas12 = _slicedToArray(_createWorkingCanvas11, 2), imageCanvas = _createWorkingCanvas12[0], ctx = _createWorkingCanvas12[1];
            designerLayer = svgElement.getElementById("designerLayer") || svgElement.firstElementChild;
            childNodes = collectEndNodes(designerLayer);
            _context4.next = 18;
            return Promise.all(childNodes.map(applyOnChildNode(imageCanvas, ctx, svgElement)));
          case 18:
            // in case of SVGImageElements with non external source the onLoad event is not fired in every browser (eg. Safari)
            // but it still does the operation sequentially so we can use it directly after setting the href attribute
            image = document.createElementNS(svgElement.namespaceURI, "image");
            image.width.baseVal.value = width;
            image.height.baseVal.value = height;
            image.href.baseVal = imageCanvas.toDataURL();
            _getScaleValues7 = getScaleValues(findOutermostNode(designerLayer, svgElement)), _getScaleValues8 = _slicedToArray(_getScaleValues7, 2), sx = _getScaleValues8[0], sy = _getScaleValues8[1];
            image.setAttribute("transform", "scale(".concat(1 / sx, ",").concat(1 / sy, ")"));
            designerLayer.innerHTML = "";
            designerLayer.appendChild(image);
            resultImgPromise = svgToImg(svgDoc);
            cache.set(key, resultImgPromise);
            _context4.next = 30;
            return resultImgPromise;
          case 30:
            return _context4.abrupt("return", _context4.sent);
          case 31:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function createEffectImg(_x7, _x8) {
      return _createEffectImg.apply(this, arguments);
    }
    return createEffectImg;
  }();
}();
function embroideryEffect(_x9) {
  return _embroideryEffect.apply(this, arguments);
}
function _embroideryEffect() {
  _embroideryEffect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(srcCanvas) {
    var options,
      getSvg,
      svgAsString,
      img,
      width,
      height,
      srcCtx,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
          _context5.next = 3;
          return imagePreloader.loadAll();
        case 3:
          getSvg = options.getSvg;
          if (getSvg) {
            _context5.next = 6;
            break;
          }
          throw new Error("The getSvg function must be provided for the embroidery effect!");
        case 6:
          _context5.next = 8;
          return getSvg();
        case 8:
          svgAsString = _context5.sent;
          _context5.next = 11;
          return createEffectImg(svgAsString, srcCanvas);
        case 11:
          img = _context5.sent;
          width = img.width, height = img.height; // copy the created image over the src canvas
          srcCtx = srcCanvas.getContext("2d");
          srcCtx.clearRect(0, 0, width, height);
          srcCtx.drawImage(img, 0, 0);
        case 16:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _embroideryEffect.apply(this, arguments);
}